import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { Button, Col, Form, Row } from "react-bootstrap";
import "../styles/EmployeeReportFilter.css";

interface FilterProps {
  filters: {
    employeeId: string;
  };
  onFilterChange: (filters: { employeeId: string }) => void;
  onReset: () => void;
}

const SalarMasterFilter: React.FC<FilterProps> = ({
  filters,
  onFilterChange,
  onReset,
}) => {
  const salaries = useSelector((state: StoreState) => state.salaryMaster.all);

  const employees = useSelector((state: StoreState) => state.employee);
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const uniqueEmployeeIds = Array.isArray(employees)
    ? Array.from(new Set(salaries.map((emp: any) => emp.employeeId))).map(
        (id) => {
          const emp = employees.find((e: any) => e.employeeId === id);
          return {
            id,
            name: emp?.name || id,
          };
        },
      )
    : [];

  const handleInputChange = (name: string, value: string) => {
    setLocalFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const renderDropdown = (
    label: string,
    name: string,
    value: string,
    options: { id: string; name: string }[],
  ) => (
    <Form.Group
      as={Col}
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className="task-filter-field"
      controlId={name}
    >
      <div className="dropdown-label">{label}</div>
      <Form.Select
        value={value}
        onChange={(e) => handleInputChange(name, e.target.value)}
        className="custom-select"
      >
        <option value="">All</option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );

  return (
    <Form className="task-filter-form">
      <Row className="g-2 align-items-end">
        {renderDropdown(
          "Employee ID",
          "employeeId",
          localFilters.employeeId,
          uniqueEmployeeIds,
        )}

        <Col className="d-flex justify-content-end align-items-center">
          <Button
            variant="primary"
            className="mr-2"
            onClick={() => onFilterChange(localFilters)}
          >
            Find
          </Button>
          <Button variant="secondary" onClick={onReset}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default SalarMasterFilter;
